<div class="main" >
    <connection-lost-bar></connection-lost-bar>
    <div class="global-progress" *ngIf="loading"></div>
    <router-outlet></router-outlet>
    <print-screen-alert *ngIf="ps.showAlert"></print-screen-alert>
</div>

